(function () {
  "use strict";

  var LOADING_FALLBACK_MS = 8000;

  function requestFullscreen(element) {
    var request =
      element.requestFullscreen ||
      element.webkitRequestFullscreen ||
      element.msRequestFullscreen;
    if (request) request.call(element);
  }

  function exitFullscreen() {
    var exit =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.msExitFullscreen;
    if (exit) exit.call(document);
  }

  function fullscreenElement() {
    return (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement ||
      null
    );
  }

  function fullscreenSupported(element) {
    return Boolean(
      element.requestFullscreen ||
        element.webkitRequestFullscreen ||
        element.msRequestFullscreen
    );
  }

  /* Size the reader to the space actually left below it, so the catalogue
     fills the canvas the moment the page opens. Measured rather than
     hard-coded because the amount of chrome above it varies: the site header,
     the announcement bar, and the bar's own height once a long title or an
     optional intro wraps. Falls back to the CSS vh value if anything here
     fails. */
  function initReaderHeight(section) {
    var shell = section.querySelector("[data-catalog-shell]");
    if (!shell || !window.requestAnimationFrame) return;

    var MIN = 420;
    /* The embed scales its page to the reader's height, so sizing purely to
       the leftover canvas made the cover small on short viewports. Keep a
       generous floor: the catalogue is the reason for the page, and a little
       scrolling costs less than a shrunken cover. */
    var FLOOR_RATIO = 0.84;

    function measure() {
      // Distance from the top of the document to the reader's top edge.
      var offset = shell.getBoundingClientRect().top + (window.pageYOffset || 0);
      var available = window.innerHeight - offset;
      var floor = Math.round(window.innerHeight * FLOOR_RATIO);

      if (available < floor) available = floor;
      if (available < MIN) available = MIN;
      section.style.setProperty("--catalog-reader-h", Math.round(available) + "px");
    }

    function schedule() {
      window.requestAnimationFrame(measure);
    }

    schedule();

    var pending;
    window.addEventListener("resize", function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(schedule, 150);
    });
    window.addEventListener("orientationchange", function () {
      window.setTimeout(schedule, 300);
    });

    // Webfonts and the site header settling can change the bar's height after
    // first paint, so re-measure once everything has loaded.
    if (document.readyState !== "complete") {
      window.addEventListener("load", schedule);
    }
  }

  function initLoadingState(section, frame) {
    var loading = section.querySelector("[data-catalog-loading]");
    if (!loading) return;

    var cleared = false;
    function clear() {
      if (cleared) return;
      cleared = true;
      loading.hidden = true;
    }

    if (frame.tagName.toLowerCase() === "iframe") {
      // Cross-origin embeds still fire load on the host element.
      frame.addEventListener("load", clear);
      // Never leave the notice stranded if the embed never reports back.
      window.setTimeout(clear, LOADING_FALLBACK_MS);
    } else {
      clear();
    }
  }

  function initFullscreen(section) {
    var shell = section.querySelector("[data-catalog-shell]");
    var button = section.querySelector("[data-catalog-fullscreen]");
    if (!shell || !button) return;
    if (!fullscreenSupported(shell)) return;

    var label = button.querySelector("[data-catalog-fullscreen-label]");
    var openLabel = button.getAttribute("data-label-open") || (label ? label.textContent : "");
    var closeLabel = button.getAttribute("data-label-close") || "Exit fullscreen";

    button.setAttribute("aria-pressed", "false");
    button.hidden = false;

    button.addEventListener("click", function () {
      if (fullscreenElement() === shell) {
        exitFullscreen();
      } else {
        requestFullscreen(shell);
      }
    });

    function syncState() {
      var active = fullscreenElement() === shell;
      button.setAttribute("aria-pressed", active ? "true" : "false");
      if (label) label.textContent = active ? closeLabel : openLabel;
    }

    document.addEventListener("fullscreenchange", syncState);
    document.addEventListener("webkitfullscreenchange", syncState);
    document.addEventListener("MSFullscreenChange", syncState);
  }

  function initCatalogueDetail(section) {
    var viewer = section.querySelector("[data-catalog-viewer]");
    var openLink = section.querySelector("[data-catalog-open]");
    if (!viewer) return;

    var frame = viewer.querySelector("iframe, object, embed");
    if (!frame) {
      // A flipbook or plain page content: nothing to wait on, so clear the
      // notice immediately. Sizing and fullscreen still apply — only the
      // embed-specific wiring below is skipped.
      var idleLoading = section.querySelector("[data-catalog-loading]");
      if (idleLoading) idleLoading.hidden = true;
      initFullscreen(section);
      initReaderHeight(section);
      return;
    }

    var title = section.getAttribute("data-catalog-title") || "Digital catalogue";
    if (frame.tagName.toLowerCase() === "iframe" && !frame.getAttribute("title")) {
      frame.setAttribute("title", title + " interactive catalogue");
    }

    if (!frame.getAttribute("loading") && frame.tagName.toLowerCase() === "iframe") {
      frame.setAttribute("loading", "eager");
    }

    if (frame.tagName.toLowerCase() === "iframe" && !frame.getAttribute("allowfullscreen")) {
      frame.setAttribute("allowfullscreen", "");
    }

    initLoadingState(section, frame);
    initFullscreen(section);

    var source = frame.getAttribute("src") || frame.getAttribute("data");
    if (openLink && source) {
      openLink.setAttribute("href", source);
      openLink.hidden = false;
    }

    // Last: revealing the fullscreen and open buttons above grows the bar, so
    // measuring any earlier would size the reader against a stale layout.
    initReaderHeight(section);
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll("[data-catalog-detail]");
    for (var index = 0; index < sections.length; index += 1) {
      initCatalogueDetail(sections[index]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
